import React, { Component, PropTypes } from 'react';
import lodash from 'lodash';
import { Button, Modal, Col, Row } from 'react-bootstrap';
import formValidation from '../../utils/formValidation';
import { onInputChange } from '../../utils/helpers';
import { Input } from '../inputs';

export default class CreateHorse extends Component {
  static propTypes = {
    isPushingData: PropTypes.bool.isRequired,
    onSubmitForm: PropTypes.func.isRequired,
    nation: PropTypes.string.isRequired,
    athlete: PropTypes.object.isRequired,
    fetchAthleteByFeiId: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    const { nation } = this.props;

    this.initialHorseData = {
      nation,
      details: {},
    };

    this.state = {
      formErrors: [],
      showCreateHorseModal: false,
      horseData: lodash.cloneDeep(this.initialHorseData),
    };

    this.onInputChange = onInputChange().bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { nation: nextNation } = nextProps;
    const { nation } = this.props;
    const { horseData } = this.state;

    if (nextNation !== nation) {
      this.initialHorseData = {
        nation: nextNation,
        details: {},
      };

      this.setState({
        horseData: { ...horseData, ...{ nation: nextNation } },
      });
    }
  }

  onGetAthleteByFeiId(refName, type) {
    const { fetchAthleteByFeiId } = this.props;

    const feiId = this.refs[refName].getValue();

    fetchAthleteByFeiId(feiId, type).then(() => {
      this.fillInputs(refName, feiId);
    });
  }

  fillInputs(refName, feiId) {
    const { horseData } = this.state;
    const { athlete } = this.props;

    const a = athlete[feiId];

    if (refName === 'horseFeiId') {
      horseData.details = {
        ...horseData.details,
        ...{
          horseFeiId: a.feiId,
          horseName: a.name,
        },
      };
    }

    this.setState({
      horseData,
    });
  }

  openCreateHorseModal = () => {
    this.setState({
      formErrors: [],
      showCreateHorseModal: true,
    });
  };

  closeCreateHorseModal = () => {
    this.setState({
      formErrors: [],
      showCreateHorseModal: false,
      horseData: lodash.cloneDeep(this.initialHorseData),
    });
  };

  handleSubmitForm = () => {
    const { onSubmitForm, addHorse } = this.props;
    const { horseData } = this.state;

    const data = { horseData };

    data.horseDetails = horseData.details;

    formValidation(data).then(formErrors => {
      this.setState({ formErrors });

      if (!!formErrors.length) {
        return;
      }

      addHorse({
        _id: '',
        ...horseData,
      });

      onSubmitForm(horseData)
        .then(() => {
          this.closeCreateHorseModal();
        })
        .catch(() => {
          this.closeCreateHorseModal();
        });
    });
  };

  renderLoadFeiId(refName, type) {
    return (
      <Button
        type="button"
        onClick={this.onGetAthleteByFeiId.bind(this, refName, type)}
        tabIndex="-1"
        style={{ marginTop: 0 }}
      >
        <i className="fa fa-refresh" />
      </Button>
    );
  }

  renderCreateHorseModal() {
    const { isPushingData } = this.props;
    const { showCreateHorseModal, formErrors, horseData } = this.state;

    return (
      <Modal show={showCreateHorseModal} onHide={this.closeCreateHorseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Horse</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form>
            <Row>
              <Col xs={6}>
                <Input
                  type="text"
                  onChange={this.onInputChange('horseData.details.horseFeiId')}
                  value={horseData.details.horseFeiId}
                  errors={formErrors}
                  name="horseFeiId"
                  label="Horse FEI ID"
                  buttonAfter={this.renderLoadFeiId('horseFeiId', 'horse')}
                  ref="horseFeiId"
                  refInput="horseFeiId"
                />
              </Col>

              <Col xs={6}>
                <Input
                  type="text"
                  onChange={this.onInputChange('horseData.details.horseName')}
                  value={horseData.details.horseName}
                  errors={formErrors}
                  name="horseName"
                  label="Horse Name"
                />
              </Col>
            </Row>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            onClick={this.handleSubmitForm}
            disabled={isPushingData}
            bsStyle="primary"
          >
            Submit
          </Button>
          <Button type="button" onClick={this.closeCreateHorseModal} disabled={isPushingData}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    if (process.env.REACT_APP_DISABLED_ENTRIES === 'true' && !this.props.isAdmin) {
      return <div />;
    }

    return (
      <div>
        {this.renderCreateHorseModal()}

        <Button
          type="button"
          bsStyle="primary"
          bsSize="sm"
          onClick={this.openCreateHorseModal}
          block
          style={{ marginTop: 5 }}
        >
          <i className="fa fa-plus" /> Add Horse
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/horse/CreateHorse.js